import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useApp } from '../../context/AppContext'

export function Layout({ children }) {
  const { state, tabs } = useApp()
  const location = useLocation()
  const currentUser = state.users.find(u => u.id === state.currentUserId)
  const isHomePage = location.pathname === '/'
  const isPlayPage = location.pathname === '/play'

  // Home page has its own full-screen layout
  if (isHomePage) {
    return <>{children}</>
  }

  // Play uses the arcade side menu from its Magic Patterns design.
  if (isPlayPage) {
    return <div className="min-h-screen bg-gray-950 text-white">{children}</div>
  }

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Top Navigation */}
      <header className="border-b border-white/10 bg-gradient-to-r from-[#0c1020] to-[#131a33]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <span className="text-2xl font-black tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500 uppercase italic">
                Cache Smash
              </span>
            </Link>

            {/* Navigation Tabs */}
            <nav className="hidden md:flex items-center gap-1">
              {tabs.map(([id, label]) => {
                const isActive = location.pathname === `/${id}` || (id === 'home' && location.pathname === '/')
                return (
                  <Link
                    key={id}
                    to={id === 'home' ? '/' : `/${id}`}
                    className={`
                      px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200
                      ${isActive
                        ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/30'
                        : 'text-gray-400 hover:text-white hover:bg-white/5'
                      }
                    `}
                  >
                    {label}
                  </Link>
                )
              })}
            </nav>

            {/* User Profile */}
            <div className="flex items-center gap-3">
              {currentUser ? (
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/5 border border-white/10">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-500/30 to-purple-500/30 flex items-center justify-center text-sm font-bold">
                    {currentUser.name?.[0]?.toUpperCase() || '?'}
                  </div>
                  <span className="text-sm font-medium hidden sm:block">{currentUser.name}</span>
                </div>
              ) : (
                <Link
                  to="/"
                  className="px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-black font-semibold rounded-lg text-sm hover:from-cyan-400 hover:to-blue-500 transition-all"
                >
                  Sign In
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden border-t border-white/10">
          <div className="flex overflow-x-auto px-4 py-2 gap-1 scrollbar-hide">
            {tabs.map(([id, label]) => {
              const isActive = location.pathname === `/${id}` || (id === 'home' && location.pathname === '/')
              return (
                <Link
                  key={id}
                  to={id === 'home' ? '/' : `/${id}`}
                  className={`
                    px-3 py-1.5 rounded-lg text-xs font-medium whitespace-nowrap transition-all
                    ${isActive
                      ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/30'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                    }
                  `}
                >
                  {label}
                </Link>
              )
            })}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between text-sm text-gray-500">
            <span>CACHE SMASH Platform Fighter</span>
            <span>v1.0.0</span>
          </div>
        </div>
      </footer>
    </div>
  )
}
